<template>
    <content-view v-if="setting" max-width="1024px">
        <v-row class="mt-8" justify="center" align="center">
            <v-col cols="auto" class="pt-0 pb-0 headline text-start">설정</v-col>
            <v-spacer></v-spacer>
            <v-col v-show="false" cols="auto" class="pt-0 pb-0">
                <v-btn class="ma-2" color="secondary" rounded @click="showSearch = !showSearch"><v-icon small class="mr-2">mdi-filter-variant</v-icon>검색필터</v-btn>
            </v-col>
        </v-row>

        <v-card class="mt-4" :disabled="!$hasScope(['root','admin'])">
            <v-card-title class="subtitle-2 font-weight-bold">
                상품권 과금설정
            </v-card-title>
            <v-divider/>
            <v-data-table :items="Object.keys(setting.riskManagement.giftcard).map(level => ({ level }))" :headers="giftcardHeaders" hide-default-footer disable-sort>

                <v-text-field slot="item.dailyLimit" slot-scope="{ item }" hide-details :value="setting.riskManagement.giftcard[item.level].dailyLimit.format()" @input="value => setting.riskManagement.giftcard[item.level].dailyLimit = +value.replace(/[^0-9]/g,'') || 0 " class="v-price-field">
                    <v-icon small slot="prepend-inner" class="mt-1">{{ mdiCurrencyKrw }}</v-icon>
                </v-text-field>
                
                <v-text-field slot="item.monthlyLimit" slot-scope="{ item }" hide-details :value="setting.riskManagement.giftcard[item.level].monthlyLimit.format()" @input="value => setting.riskManagement.giftcard[item.level].monthlyLimit = +value.replace(/[^0-9]/g,'') || 0 " class="v-price-field">
                    <v-icon small slot="prepend-inner" class="mt-1">{{ mdiCurrencyKrw }}</v-icon>
                </v-text-field>

                <v-text-field slot="item.commission" slot-scope="{ item }" hide-details :value="setting.riskManagement.giftcard[item.level].commission.format()" @input="value => setting.riskManagement.giftcard[item.level].commission = +value.replace(/[^0-9]/g,'') || 0 " class="v-number-field">
                    <v-icon small slot="append" class="mt-1">{{ mdiPercentOutline  }}</v-icon>
                </v-text-field>
            </v-data-table>
        </v-card>

        <v-row justify="center" class="mt-4">
            <v-btn :disabled="!$hasScope(['root','admin'])" color="primary" @click="save">저장</v-btn>
        </v-row>
    </content-view>
</template>

<script>
import api from "@/api";
import { mdiCurrencyKrw, mdiPercentOutline  } from '@mdi/js';
import banks from "@/assets/data/banks.json";
import vPasswordField from "@/components/plugins/vuetify/v-password-field.vue";
import ContentView from "@/pages/console/templates/ConsoleContent.vue";
import Input from '@/components/client/board/skin/board-normal/input.vue';

export default {
    components: {
        vPasswordField,
        ContentView,
        Input
    },
    created() {
        this.init();
    },
    data() {
        return {
            mdiCurrencyKrw,
            mdiPercentOutline ,

            setting: null,
            banks,

            giftcardHeaders: [
                { text: "등급", value: "level", width: 200, align: "center" },
                { text: "일간 구매한도(원)", value: "dailyLimit", align: "center" },
                { text: "월간 구매한도(원)", value: "monthlyLimit", align: "center" },
                // { text: "수수료(%)", value: "commission", width: 128, align: "center" },
            ]
        };
    },
    mounted(){
        this.init();
    },
    methods: {
        async init(){
            let { setting } = await api.console.setting.get();
            this.setting = setting;
        },

        async save(){
            await api.console.setting.put(this.setting);
            alert("저장되었습니다");
        },
    },

    computed: {

    }
}
</script>

<style scoped>
.v-price-field,
.v-number-field {
    margin: 8px 0;
}
.v-price-field >>> input {
    text-align: right !important;
    padding-right: 8px;
}
.v-number-field >>> input {
    text-align: right !important;
}
</style>
